import { render, staticRenderFns } from "./button_upload_image.vue?vue&type=template&id=2bbf408a&scoped=true&lang=pug"
import script from "./button_upload_image.vue?vue&type=script&lang=js"
export * from "./button_upload_image.vue?vue&type=script&lang=js"
import style0 from "./button_upload_image.vue.css?vue&type=style&index=0&id=2bbf408a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbf408a",
  null
  
)

export default component.exports